import BreadcrumbsStore from '../../shared/stores/BreadcrumbsStore';
import GlobalBreadcrumbsMixin from '../../shared/Mixins/GlobalBreadcrumbsMixin';

export default {
  mixins: [GlobalBreadcrumbsMixin],

  mounted () {
    this.setUserRootBreadcrumbs();
  },

  methods: {
    setUserRootBreadcrumbs () {
      BreadcrumbsStore.setItems([
        { text: this.$t("sidebar.userProfile"), to: { name: 'Edit User', params: { id: this.user.id } } },
        { text: `${this.user.first_name} ${this.user.last_name}`, to: { name: 'Edit User', params: { id: this.user.id } } }
      ]);
    }
  }
};
